import { createSelector } from "../reselect";
import { getNewStats, total, simpleChart, safeDivide, simpleChart2, simpleChartMinus } from "../generalUtils";

const providerId = "smsbump";

const smsbumpRevenue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "conversion_value")
);
const smsbumpRevenueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "conversion_value")
);

const smsbumpCampaignRevenue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "campaign_conversion_value")
);
const smsbumpCampaignRevenueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "campaign_conversion_value")
);

const smsbumpFlowRevenue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "flow_conversion_value")
);
const smsbumpFlowRevenueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "flow_conversion_value")
);

const smsbumpSpend = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "spend")
);
const smsbumpSpendChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "spend")
);

const smsbumpSent = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "sent")
);
const smsbumpSentChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "sent")
);

const smsbumpUnsubscribed = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "unsubscribed")
);
const smsbumpUnsubscribedChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "unsubscribed")
);

const smsbumpConversions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "conversions")
);
const smsbumpConversionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "conversions")
);

const smsbumpDelivered = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "delivered")
);
const smsbumpDeliveredChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "delivered")
);

const smsbumpClicks = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "clicks")
);
const smsbumpClicksChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "clicks")
);

const smsbumpAov = createSelector(
  [smsbumpRevenue, smsbumpConversions],
  (smsbumpRevenue, smsbumpConversions) => {
    return safeDivide(smsbumpRevenue, smsbumpConversions);
  }
);
const smsbumpAovChart = createSelector(
  [smsbumpRevenueChart, smsbumpConversionsChart],
  (smsbumpRevenueChart, smsbumpConversionsChart) =>
    simpleChart2(smsbumpRevenueChart, smsbumpConversionsChart)
);

const smsbumpCtr = createSelector(
  [smsbumpClicks, smsbumpDelivered],
  (smsbumpClicks, smsbumpDelivered) => {
    return safeDivide(smsbumpClicks, smsbumpDelivered);
  }
);
const smsbumpCtrChart = createSelector(
  [smsbumpClicksChart, smsbumpDeliveredChart],
  (smsbumpClicksChart, smsbumpDeliveredChart) =>
    simpleChart2(smsbumpClicksChart, smsbumpDeliveredChart)
);

const smsbumpRoas = createSelector(
  [smsbumpRevenue, smsbumpSpend],
  (smsbumpRevenue, smsbumpSpend) => {
    return safeDivide(smsbumpRevenue, smsbumpSpend);
  }
);
const smsbumpRoasChart = createSelector(
  [smsbumpRevenueChart, smsbumpSpendChart],
  (smsbumpRevenueChart, smsbumpSpendChart) =>
    simpleChart2(smsbumpRevenueChart, smsbumpSpendChart)
);

const smsbumpRoi = createSelector(
  [smsbumpRevenue, smsbumpSpend],
  (smsbumpRevenue, smsbumpSpend) => {
    return safeDivide(smsbumpRevenue - smsbumpSpend, smsbumpSpend);
  }
);
const smsbumpRoiChart = createSelector(
  [smsbumpRevenueChart, smsbumpSpendChart],
  (smsbumpRevenueChart, smsbumpSpendChart) =>
    simpleChart2(simpleChartMinus(smsbumpRevenueChart, smsbumpSpendChart), smsbumpSpendChart)
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    smsbumpRevenue,
    smsbumpRevenueChart,
    smsbumpCampaignRevenue,
    smsbumpCampaignRevenueChart,
    smsbumpFlowRevenue,
    smsbumpFlowRevenueChart,
    smsbumpSpend,
    smsbumpSpendChart,
    smsbumpSent,
    smsbumpSentChart,
    smsbumpUnsubscribed,
    smsbumpUnsubscribedChart,
    smsbumpConversions,
    smsbumpConversionsChart,
    smsbumpAov,
    smsbumpAovChart,
    smsbumpCtr,
    smsbumpCtrChart,
    smsbumpRoas,
    smsbumpRoasChart,
    smsbumpRoi,
    smsbumpRoiChart,
    smsbumpDelivered,
    smsbumpDeliveredChart,
    smsbumpClicks,
    smsbumpClicksChart,
  },
};